import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ServicesProvider } from 'src/providers/services';
import { AlertController, LoadingController, ModalController, ToastController, IonContent, PopoverController, IonSlides, Platform } from '@ionic/angular';
import * as moment from 'moment';
import { DatePikerPage } from '../date-piker/date-piker.page';
import { DatePipe, formatDate } from '@angular/common';
import { DomSanitizer } from "@angular/platform-browser";
import { InViewportMetadata } from 'ng-in-viewport';
import { PopupalertPage } from '../popupalert/popupalert.page';
import { CancelbookingPage } from '../cancelbooking/cancelbooking.page';
import { ReviewPage } from '../review/review.page';
import { AddmemPage } from '../addmem/addmem.page';
import { AddCall } from 'src/providers/addvCall';
import { Payment } from 'src/providers/payment';
import { RoomDetailsPage } from '../booking-room/room-details/room-details.page';
import { ModpricetagPage } from '../modpricetag/modpricetag.page';
import { MediapopupPage } from '../mediapopup/mediapopup.page';
import { CallNumber } from '@ionic-native/call-number/ngx';
import { RatingSortpagePage } from '../rating-sortpage/rating-sortpage.page';
import { AdvertisementPage } from '../advertisement/advertisement.page';
import { SuccessPage } from 'src/app/success/success.page';
import { ViewmodelPage } from '../viewmodel/viewmodel.page';
import { knetPaymentDetailsPage } from '../success/knetPaymentDetails/knetPaymentDetails.page';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import * as htmlToPdfmake from 'html-to-pdfmake';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
pdfMake.vfs = pdfFonts?.pdfMake?.vfs;


interface DecryptedMemberContentResponse {
  data: { Terms_and_conditions: string }[];
}

@Component({
  selector: 'app-booking-room',
  templateUrl: './booking-room.page.html',
  styleUrls: ['./booking-room.page.scss'],
})
export class BookingRoomPage implements OnInit {

  @Output() ChangeEvent = new EventEmitter<string>();
  @ViewChild(IonContent, { static: false }) ionContent: IonContent;
  @ViewChild(IonSlides, { static: false }) slides: IonSlides;
  @Input() typeid: any; @Input() showTypeofBooking: string;
  terms_and_condition_file: any;
  private fkey = CryptoJS.enc.Hex.parse(
    '00112233445566778899aabbccddeeff00112233445566778899aabbccddeeff'
  );
  private fiv = CryptoJS.enc.Hex.parse('00112233445566778899aabbccddeeff');
  // @ViewChild('content') ionContent: IonContent;
  particular_roomdetails: boolean = false; test: any = "id"; rate: any; presentView: string; playVid: any;
  muteMode: boolean;
  //-------Pages---------------
  bookARoom: boolean; hospitalList: boolean; hospitalDetails: boolean; bookingConf1: boolean; bookingPage: boolean;
  bookingConf2: boolean; bookingHistory: boolean; viewBooking: boolean; viewBookingHistory: boolean;

  //-------Events--------------
  maxCost: any = "0"; minCost: any = "0"; mCost: any = "0"; fromBookList: boolean; fromBooking: boolean; goesToList: boolean;
  goesToBooking: boolean; showRefundPopUp: boolean; showRefundPopUp1: boolean; Chreselect: boolean = false;


  //API....
  PatRoomSearch = []; currentDate: any; typeSearch: boolean; searchContent: any; fDate1: any; tDate1: any; noDataFound: any;
  dateFilter: boolean = true; partHospRoomList = []; partRoomVendorName: any; costStatus: boolean; costBasedSortingOrder: any
  costSorting: boolean = false; myRoomId: any; ParticularRoomDetails = []; TotalDays: number; PatientProfile: any = [];
  myNameInput: any; myAddress: any; myNameInput1: any; currentMemberId: any; roomId: any; roomVendorId: any; cost: any;
  RoomBookedDetails = []; datls = [1, 2]; partBookedRoomDetails = []; totalCost: any; totalCost1: number;
  RoomBookedHistory = []; viewBookingHistoryPage = []; rescheduleDatas = []; fromDateAPI: any; toDateAPI: any;
  patientName: any; oldBookingId: any; patientID: any; reRoomId: any = null; BookedDate: any; refundAmount: number;  isConfirmed : boolean

  toPay: number; refundStatus: number; roomBookingId1: any; totalAmountRefund: any; skeletonLoad1: any;
  skeletonLoad2: any; nextCount: any; nextCountOm: any; pageno1: any; limit1: any; executed1: boolean; executed2: boolean
  pageno2: any; fromDate1: any; toDate1: any; pageno3: any; pageno4: any; bookedStatus: boolean; fromPage1: string;
  totSkeleten: any = []; Enabled: any; showVideoOptins: any; ProfileVideo: any; isPlaying: boolean = false; RepeatDatas = [];
  isRepeat: boolean; roomVendorName: any; frmDateResch: any; toDateResch: any; roomSearchReq: any; famMemId: any;
  refEvent: any; scrollEvent: any; tymVal: any; roomListReq: any; costReq: any; partRoomDetReq: any; patProReq: any;
  roomBookReq: any; roomBookListReq: any; bookHisReq: any; roomReschReq: any; roomCancelReq: any; isMember: number;
  tempMemberName: any; pat_mem_id: any; dealitem: any; deal_check: any; totalCost12: number; datecl: boolean;
  rev_commands: any; res_book_date_frm: any; res_book_date_to: any; reschedule_pg_dte: boolean; res_can: boolean;
  dealopt: any; delval: any; ratingSorting: boolean; ratingBasedSortingOrder: any; checkrepeat: any; paymentid: any; referenceid: any;
  orderId: any; paymentGateway: any; bookingpagevalue: boolean;
  backhidden: any; dynClass: string; addImg: any; payType: any; currentIndex: any;
  gopayment: boolean = false;
  isMuteVideo: boolean = false;
  currentVidEvent: any;
  currentVidIndex: any;
  currentVidSindex: any;
  currentVideo: any;
  headerValue: string;
  storedPath: null;
  addtype: any;
  lattitude: any;
  longititude: any;
  distanceInKilometers: any;
  priceTitleShow: boolean = false;
  LocationIcon:any;
  latitude:any;
  longitude:any;
  repeatressuccess: any = 0;
  repetroomid: any;
  routeId: any;
  payload: any;
  constructor(public router: Router,
    public alertCtrl: AlertController,
    public activeRoute: ActivatedRoute,
    private services: ServicesProvider,
    public toastController: ToastController,
    private modalCtrl: ModalController,
    private datePipe: DatePipe,
    private loadingCtrl: LoadingController,
    private sanitizer: DomSanitizer,
    public PopupalertPage: PopupalertPage,
    public addCall: AddCall,
    private payment: Payment,
    public popoverCtrl: PopoverController,
    public call: CallNumber,
    private geolocation: Geolocation,
    private platform: Platform,
    private file: File,
    private fileOpener: FileOpener,
    private httpClient: HttpClient,


  ) { }


  async ngOnInit() {
    this.activeRoute.queryParams.subscribe(params => {
      const id = params['id'];
      this.routeId = id;
      console.log(id)
    });
    localStorage.setItem('bookindId', this.routeId);
    localStorage.setItem('VendorType', "10");
    await this.paymentCheck()
    this.totSkeleten = [1, 2, 3, 4, 5];
  }

  setEnable1() {
    console.log(this.Chreselect);

    if (this.Chreselect == true) {
      this.Enabled = true;
      this.openDatePicker1();
    }
  }

  setEnable2() {
    if (this.Chreselect == true) {
      this.Enabled = true;
      this.openDatePicker2();
    }

  }
  async getWalkinPaymentDetails(){
    const requestdata = {
      "id": this.routeId
  }
    this.roomBookReq = this.services.postRequestRoom("getWalkinPaymentDetails", requestdata).subscribe(async response => {
      debugger;
      const data = response.data;
      this.roomVendorId = data[0].vendor_id
      this.currentMemberId =  data[0].patient_id

      this.myNameInput = data[0].member_name;
      this.myAddress = data[0].vendor_address;
      this.tempMemberName = data[0].member_name;
      // this.PatientProfile = data[0];
      this.Email = data[0].member_emailId == "" ? "admin@theonemoment.com" : data[0].member_emailId;
      this.Phoneno = data[0].member_mobileNo;
      localStorage.setItem("patient_id", data[0].patient_id);
      localStorage.setItem("vendor_id", data[0].vendor_id);
    


      if (data[0].Paymentstatus == "Already Paid" || localStorage.getItem("paymentstatus") == "completed") {
        localStorage.setItem("walkPaymentstatus", data[0].Paymentstatus)
        this.presentView = "paid";
      } else if (data[0].Paymentstatus == "Payable") {
        await this.minMaxCostForBookARoom(this.roomVendorId )
        await this.Show_ParticularRoom(this.roomVendorId);
        this.presentView = "hospitalList";
        localStorage.setItem("walkPaymentstatus", data[0].Paymentstatus);
      } else if (data[0].Paymentstatus == "not available") {
        debugger
        localStorage.setItem("Failer", data);
        console.log(data);
      } else {
        console.log(data);
      }
    })
  }
  async openDatePicker1() {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        'selectedDate': null,
        'calenderType': "normal",
        curdate: new Date().toString().split(' ')[0] + ", " + new Date().toString().split(' ')[1] + " " + new Date().toString().split(' ')[2]    //normal/dob
      }
    });
    await datePickerModal.present();

    datePickerModal.onDidDismiss()
      .then((data) => {

        console.log("checking data", data);
        if (data.data) {
          let Date1 = data.data
          this.fromDate1 = Date1.getFullYear() + "-" + ("0" + (Date1.getMonth() + 1)).slice(-2) + "-" + ("0" + (Date1.getDate())).slice(-2);
          console.log("from date 1", this.fromDate1);
          this.dynamicFromDate();
        }
      });
  }

  async openDatePicker2() {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        'selectedDate': null,
        'calenderType': "normal",
        curdate: new Date().toString().split(' ')[0] + ", " + new Date().toString().split(' ')[1] + " " + new Date().toString().split(' ')[2]   //normal/dob
      }
    });
    await datePickerModal.present();

    datePickerModal.onDidDismiss()
      .then((data) => {
        console.log("testing details", data.data);
        console.log("testing checking  details", this.fromDate1);
        let condition = data.data.getFullYear() + "-" + ("0" + (data.data.getMonth() + 1)).slice(-2) + "-" + ("0" + (data.data.getDate())).slice(-2);

        console.log("testing for find", condition);
        if (condition != this.fromDate1 && condition > this.fromDate1) {
          let Date2 = data.data;
          this.toDate1 = Date2.getFullYear() + "-" + ("0" + (Date2.getMonth() + 1)).slice(-2) + "-" + ("0" + (Date2.getDate())).slice(-2);
          this.dynamicToDate();

        }
        else {
          this.BookARoomToast("End date should be greater than Start date");
        }
      });
  }

  async doRefresh(event: any, value: any) {
    this.refEvent = event;
    if (value == "listRoom") {
      this.getRoomList(3);
    }
    else if (value == 'listBooking') {
      this.bookedList("refresh");
    }
    else if (value == "listBookingHis") {
      this.bookedHistoryList("refresh");
    }
    else if (value == "listHospital") {
      this.particularRoomList("refresh");
      await this.particularHospitalRoomList();

    }
  }

  async ionViewWillEnter() {

    // this.presentView = "hospitalList";
    await this.getWalkinPaymentDetails()
    this.fDate1 = this.getFormattedDateTime(new Date(), "Date1");
    let tDate = new Date().setDate(new Date().getDate() + 1);
    this.tDate1 = this.getFormattedDateTime(tDate, "Date1");
    this.fromDate1 = new Date().toISOString().split("T")[0];
    this.toDate1 = new Date(tDate).toISOString().split("T")[0];
    this.videoPlayDestroy();
    this.playVid = ""
    this.ChangeEvent.emit('profile');
    this.distanceInKilometers = "22.00";
    this.selectedroomdetails = [];
    this.roomname = null;
    this.Chreselect = true
    this.executed2 = true;
    this.costSorting = false;
    // this.roomVendorId = id;
    this.costBasedSortingOrder = "ASC";
    await this.particularRoomList(1);
    // await this.particularHospitalRoomList();
    this.costStatus = true;

    this.hospitalList = true;
    this.bookARoom = false;
  }
  async ionViewWillLeave() {
    await this.videoPlayDestroy()
    this.playVid?.pause?.();
    this.playVid = null
    if (this.ProfileVideo != undefined) {

      this.ProfileVideo.pause();
      this.ProfileVideo = ""
    }
    let video = this.currentVideo;
    let playPromise = video?.play?.();
    if (playPromise !== undefined) {
      playPromise.then(_ => {
        video.pause();
      })
        .catch((err: any) => {
          video.pause();
        });
    }
    this.isMuteVideo = false;
    this.scrollEvent = null;
    // for (let i = 1; i <= 2; i++) {
      setTimeout(async () => {
        const topModal = await this.modalCtrl.getTop();
        if (topModal) {
          this.modalCtrl.dismiss({});
        }
      }, 1000);  // Delay increases by 1000ms (1 second) each time
    // }
    // this.modalCtrl.dismiss({});
    console.log("===============================>Leave");

  }
  async ionViewDidLeave() {
    this.isMuteVideo = false;
    this.currentVideo?.pause?.()
    this.currentVidEvent = "";
    this.currentVidIndex = "";
    this.currentVidSindex = "";
    this.partHospRoomList = [];
    this.playVid?.pause();
    this.playVid = ""
    if (this.ProfileVideo != undefined) {
      this.ProfileVideo?.pause?.();
      this.ProfileVideo = ""
    }
    let video = this.currentVideo;
    let playPromise = video?.play?.();
    if (playPromise !== undefined) {
      playPromise.then(_ => {
        video.pause();
      })
        .catch((err: any) => {
          video.pause();
        });
    }
    this.isMuteVideo = false;
    this.isConfirmed = false
    this.scrollEvent = null;
    setTimeout(() => {
      if (this.ProfileVideo != undefined) {

        this.ProfileVideo.pause();
        this.ProfileVideo = ""
      }
      let video = this.currentVideo;
      let playPromise = video?.play?.();
      if (playPromise !== undefined) {
        playPromise.then(_ => {
          video.pause();
        })
          .catch((err: any) => {
            video.pause();
          });
      }
      this.isMuteVideo = false;
      this.scrollEvent = null;
    }, 1000);
    const topModal = await this.modalCtrl.getTop();
    if (topModal) {
    this.modalCtrl.dismiss({});
    }
    // this.modalCtrl.dismiss({});
    console.log("===============================>Leave");
  }


  async BookARoomToast(msg) {
    const toast = await this.toastController.create({
      message: msg, duration: 2000, cssClass: 'myToastStyleBig',
    });
    toast.present();
  }


  async showBookingRoom() {
    this.executed1 = true;
    this.searchContent = "";
    if (this.searchContent == "") {
      this.typeSearch = false;
    }
    this.currentDate = new Date();
    this.fDate1 = this.getFormattedDateTime(new Date(), "Date1");
    let tDate = new Date().setDate(new Date().getDate() + 1);
    this.tDate1 = this.getFormattedDateTime(tDate, "Date1");
    this.fromDate1 = new Date().toISOString().split("T")[0];
    this.toDate1 = new Date(tDate).toISOString().split("T")[0];
    this.bookARoom = true;
    await this.getRoomList(1);
    await this.minMaxCostForBookARoom('');
    this.presentView = "bookARoom";
    setTimeout(async () => {
      await this.patientRoomSearch();
    }, 50);
    this.hospitalList = false;
    this.hospitalDetails = false;
    this.bookingConf1 = false;
    this.bookingPage = false;
    this.bookingConf2 = false;
    this.bookingHistory = false;
    this.viewBookingHistory = false;
    this.viewBooking = false;
    this.showRefundPopUp = false;
  }
  backToHome() {
    // Ensure all videos are paused
    this.videoPlayDestroy();
    // Navigate to the home page
    this.router.navigate(['/tabs/home']);
    // Reset all states
    this.bookARoom = false;
    this.hospitalList = false;
    this.hospitalDetails = false;
    this.bookingConf1 = false;
    this.bookingPage = false;
    this.bookingConf2 = false;
    this.bookingHistory = false;
    this.viewBookingHistory = false;
    this.viewBooking = false;
    this.showRefundPopUp = false;
    this.isMuteVideo = false;
    this.ionViewWillLeave();
  }


  async openHospitalList(roomVendorId, checkcal,distance) {
    // this.playVid?.pause();
    this.videoPlayDestroy();
    this.playVid = ""
    console.log(roomVendorId, "room id");
    this.ChangeEvent.emit('profile');
    this.distanceInKilometers = distance?.toFixed(2);
    this.Show_ParticularRoom(roomVendorId);
    this.selectedroomdetails = [];
    this.roomname = null;
    console.log(checkcal, '========================>');
    this.Chreselect = checkcal
    this.executed2 = true;
    this.costSorting = false;
    this.roomVendorId = roomVendorId;
    this.costBasedSortingOrder = "ASC";
    await this.particularRoomList(1);
    await this.particularHospitalRoomList();
    this.costStatus = true;

    this.presentView = "hospitalList";
    this.hospitalList = true;
    this.bookARoom = false;
  }
  backToBookARoom() {
    this.partHospRoomList = [];
    this.videoPlayDestroy();
    this.playVid = ""
    this.ProfileVideo?.pause();
    let video = this.currentVideo;
    let playPromise = video.pause();
    if (playPromise !== undefined) {
      playPromise.then(_ => {
        video.pause();
      })
      .catch((err: any) => {
        video.pause();
      });
    }
    console.log(this.Chreselect, "========>");
    if (this.Chreselect == true) {
      this.hospitalList = false;
      this.showcoment = false;
      this.backToBookingHistoy()
    }
    else {
      this.ionViewWillEnter();
      // this.getRoomList(10);
      this.presentView = "bookARoom";
      this.bookARoom = true;
      this.hospitalList = false;
      this.showcoment = false;
    }
    this.isMuteVideo = false;
    this.isConfirmed = false
  }


  openHosDetails(roomId, item) {
    this.particular_roomdetails = true;
    console.log("ra", item.roomAvailable);
    console.log(this.Chreselect, '========>');

    this.datecl = false;
    console.log("checking", item);
    this.dealitem = item;
    this.myRoomId = roomId
    this.getParticularRoomDetails(this.myRoomId, "");
  }
  backToHosList1() {
    if (this.isRepeat == false) {
      this.presentView = "hospitalList";
      this.hospitalList = true;
      this.hospitalDetails = false;
      this.fromBookList = false;
    } else {
      this.presentView = "bookingHistory";
      this.bookingHistory = true;
      this.hospitalDetails = false;
      this.fromBookList = false;
    }
    this.isMuteVideo = false;
    this.isConfirmed = false

  }
  backtohospitallist() {
    this.presentView = "hospitalList";
    this.hospitalList = true;
    this.hospitalDetails = false;
    this.fromBookList = false;
    this.isMuteVideo = false;
    this.isConfirmed = false
    this.backToHosDetls1();
  }
  backToHosList2() {
    this.presentView = "bookingPage";
    this.headerValue = this.addCall.title133;
    this.bookingPage = true;
    this.hospitalDetails = false;
    this.fromBooking = false;
    this.isMuteVideo = false;
    this.isConfirmed = false

  }

  backToBookHis() {
    this.presentView = "bookingHistory";
    this.bookingHistory = true;
    this.hospitalDetails = false;
    this.fromBooking = false;
  }

  openBookingConform(dealitem) {
    this.showcoment = false;
    console.log("deal item", dealitem, this.cost);
    this.deal_check = dealitem;
    console.log("Booking", dealitem);
    let now = new Date().toISOString().split("T")[0];
    if (this.fromDate1 >= now) {
      if (this.toDate1 >= this.fromDate1) {
        this.hospitalList = false;
        this.presentView = "bookingConf1";
        this.bookingConf1 = true;
        this.bookingConf2 = false;
        this.hospitalDetails = false;
        this.getPatientProfile();
      } else {
        this.BookARoomToast("To Date should be Greater than or Equal to the From Date");
      }
    } else {
      this.BookARoomToast("From Date should be Greater than or Equal to the Current Date")
    }
    //Event..............
    let start = moment(this.fromDate1);
    let end = moment(this.toDate1);
    console.log(end.diff(start, "days"));
    this.TotalDays = 0;
    if (this.fDate1 === this.tDate1) {
      this.TotalDays = 1;
    } else {
      this.TotalDays = end.diff(start, "days");
    }
    if (this.deal_check.dealOption == 'Amount') {
      console.log(this.deal_check.dealValue);
      console.log(this.TotalDays);

      this.totalCost = (this.deal_check.cost * this.TotalDays) - this.deal_check.dealValue
    } else if (this.deal_check.dealOption == 'Percentage') {
      this.totalCost12 = (this.deal_check.cost * this.TotalDays) / 100
      let totalvalue = this.totalCost12 * this.deal_check.dealValue
      this.totalCost = (this.deal_check.cost * this.TotalDays) - totalvalue
      console.log("checking0987654", this.totalCost)
    } else if (this.deal_check.dealOption != 'Percentage' && this.deal_check.dealOption != 'Amount') {
      this.totalCost = this.deal_check.cost * this.TotalDays
    }
  }

  openBookingConf(deal) {
    console.log("deal", deal);

    const start = moment(this.fromDate1);
    const end = moment(this.toDate1);
    this.calculateTotalDays(start, end);
    this.calculateTotalCost();
    this.calculateRefund();

    if (this.areDatesValid()) {
      if (this.isReschedulingAllowed()) {
        this.processBookingConfirmation();
      } else {
        this.BookARoomToast("cannot reschedule to same check-in and check-out date as booked.");
      }
    }
  }

  calculateTotalDays(start, end) {
    console.log(end.diff(start, "days"));
    if (this.fDate1 === this.tDate1 || !this.fDate1 || !this.tDate1) {
      this.TotalDays = 1;
    } else {
      this.TotalDays = end.diff(start, "days") + 1;
    }
  }

  calculateTotalCost() {
    if (this.dealopt === 'Amount') {
      this.totalCost1 = (this.cost - this.delval) * this.TotalDays;
    } else if (this.dealopt === 'Percentage') {
      this.totalCost12 = (this.cost * this.delval) / 100;
      this.totalCost1 = (this.cost - this.totalCost12) * this.TotalDays;
    } else {
      this.totalCost1 = this.cost * this.TotalDays;
    }
    console.log("totalCost1 ---> ", this.totalCost1);
    this.toPay = this.totalCost1 - this.rescheduleDatas[0].amount;
  }

  calculateRefund() {
    if (this.totalCost1 - this.rescheduleDatas[0].amount < 0) {
      this.refundAmount = this.rescheduleDatas[0].amount - this.totalCost1;
      this.refundStatus = 1;
    } else {
      this.refundAmount = 0;
      this.refundStatus = 0;
    }
    console.log("refundAmount ----> ", this.refundAmount);
  }

  areDatesValid() {
    const now = new Date().toISOString().split("T")[0];
    if (this.fromDate1 >= now) {
      if (this.toDate1 >= this.fromDate1) {
        return true;
      } else {
        this.BookARoomToast("To Date should be Greater than or Equal to the From Date");
      }
    } else {
      this.BookARoomToast("From Date should be Greater than or Equal to the Current Date");
    }
    return false;
  }

  isReschedulingAllowed() {
    return (this.fromDate1 !== this.frmDateResch && this.toDate1 === this.toDateResch) ||
      (this.fromDate1 === this.frmDateResch && this.toDate1 !== this.toDateResch) ||
      (this.fromDate1 !== this.frmDateResch && this.toDate1 !== this.toDateResch);
  }

  processBookingConfirmation() {
    this.getPatientProfile();
    this.presentView = "bookingConf2";
    this.bookingConf2 = true;
    this.hospitalDetails = false;
    this.myNameInput1 = this.patientName;
  }

  backToHosDetls1() {
    this.presentView = 'hospitalList';
    this.hospitalDetails = false;
    this.hospitalList = true;
    this.goesToList = false;
    this.goesToBooking = false;
    this.isConfirmed = false
    this.bookingConf1 = false;
    this.isMuteVideo = false;
    this.fromBookList = true;

  }
  backToHosDetls2() {
    this.presentView = "hospitalDetails";
    this.hospitalDetails = true;
    this.isMuteVideo = false;
    this.goesToBooking = true;
    this.isConfirmed = false
    this.goesToList = false;
    this.bookingConf2 = false;
  }

  async goToPayment() {

    console.log(this.deal_check.cost, this.deal_check.dealOption, this.deal_check.dealValue, this.totalCost);
    await this.presentModal1();

  }
  async patientRoomBooking(res: any) {
    if (this.roomBookReq) {
      this.roomBookReq.unsubscribe();
    }


    const loading = await this.loadingCtrl.create({
      message: 'Processing Your Payment Status',
    });
    await loading.present();

    let data = JSON.stringify(this.payload)
    
    this.roomBookReq = this.services.postRequest("patientRoomBooking", data).subscribe(async response => {
      console.log(response);
      debugger
      await loading.dismiss();
      if (response.status == 1) {
        //------------------------------
        localStorage.setItem("payBack", "booking-room");
        if (localStorage.getItem("cardType") == "Knet") {
          this.showKnetPaymentDetals(res, this.addCall.title620);
        }
        else if (localStorage.getItem("cardType") == "MasterCard") {
          this.presentView = "paid";
          // this.router.navigate(['/payment', { paymentstatus: 1 }]);
        }

        this.bookingConf1 = false;
        this.localClear();
        // await this.getWalkinPaymentDetails()
        //------------------------------
      } else {
        this.Alertpopup(response.msg, response.status);
      }
    });
  }

  playSound() {
    let audio = new Audio();
    audio.src = "../assets/audio/tick.mp3";
    audio.load();
    audio.play();
  }


  async showPopover(frm: any, cname: any, facilityId: number, event: any) {
    const clickedRoom = this.ParticularRoomDetails[0];
    const clickedFacility = clickedRoom.facility.find(facility => facility.facilityId === facilityId);
    if (clickedFacility) {
      const popover = await this.popoverCtrl.create({
        component: ViewmodelPage,
        showBackdrop: true,
        backdropDismiss: false,
        translucent: true,
        componentProps: {
          From: frm,
          itemname: clickedFacility.facilityName,
        },
        cssClass: cname,
        event: event,
      });
      return await popover.present();
    }
  }

  async gatewayFunction(res: any, paymentGateway: any) {
    console.log(res, "response");
    if (res.status == '1') {
    let loaddatastring = localStorage.getItem("requestdata")
    let loaddataobject = JSON.parse(loaddatastring)
    loaddataobject.paymentid = res.paymentId;    
    loaddataobject.referenceid = res.sessionid;    
    loaddataobject.order_id = res.orderId;    
    loaddataobject.paymentGateway = res.paymentGatewayName;   

      this.payload = loaddataobject
      this.patientRoomBooking(res);
      this.playSound();
    }
    else if (res.status == '2') {
      this.Alertpopup("Payment Cancelled", 0)
    }
    else {
      console.log('payment faild');
      if (paymentGateway == "KNET") {
        this.showKnetPaymentDetals(res, "Payment Failure Details");
      } else {
        this.Alertpopup(this.addCall.title602, 0)
      }
    }
  }


  rescheduleIt() {
    this.patientRoomBookingReschedule();
  }

  async openBooking1() {
    if (this.showTypeofBooking == "booking") {
      this.presentView = "bookingPage"
    }
    if (this.presentView != "viewBookingHistory" && this.presentView != "bookingHistory") {
      this.ChangeEvent.emit('isRoomBack');
      this.bookedList(1);
      this.fromPage1 = "page1";
      this.presentView = "bookingPage";
      this.bookingPage = true;

      this.bookingHistory = false;
      this.bookARoom = false;
      this.viewBooking = false;
    }
  }
  openBooking2() {
    this.bookedList(2);
    this.fromPage1 = "page2";
    this.presentView = "bookingPage";
    this.bookingPage = true;

    this.bookingHistory = false;
    this.hospitalList = false;
    this.viewBooking = false;
  }
  async backToBookRoom() {
    this.executed1 = true;
    this.isConfirmed = false

    this.searchContent = "";
    if (this.searchContent == "") {
      this.typeSearch = false;
    }


    this.fDate1 = this.getFormattedDateTime(new Date(), "Date1");
    let tDate = new Date().setDate(new Date().getDate() + 1);
    this.tDate1 = this.getFormattedDateTime(tDate, "Date1");
    this.fromDate1 = new Date().toISOString().split("T")[0];
    this.toDate1 = new Date(tDate).toISOString().split("T")[0];

    if (this.fromPage1 == "page1") {
      this.getRoomList(2);
      this.presentView = "bookARoom";
      this.bookARoom = true;
    } else if (this.fromPage1 == "page2") {
      this.particularRoomList(1)
      await this.particularHospitalRoomList();
      this.presentView = "hospitalList";
      this.hospitalList = true;
      console.log('======================================>check repeat');
      this.Chreselect = false;
    }
    this.bookingPage = false;
    this.isMuteVideo = false;
    this.isConfirmed = false

  }

  openSchedule(index, roomId, item) {
    this.reschedule_pg_dte = true;
    this.res_book_date_frm = item.book_date_from;
    this.res_book_date_to = item.bookfDate1br_from_date_date_to;
    console.log("from", this.res_book_date_frm);
    console.log("from", this.res_book_date_to);
    this.datecl = true;
    console.log("roomId -----> ", roomId);
    this.rescheduleDatas = [];
    this.rescheduleDatas.push(this.RoomBookedDetails[index]);
    this.getParticularRoomDetails(roomId, "");

    // API DATA'S.............
    this.fromDate1 = this.RoomBookedDetails[index].book_date_from.split("T")[0];
    this.toDate1 = this.RoomBookedDetails[index].book_date_to.split("T")[0];
    this.fDate1 = this.getFormattedDateTime(this.fromDate1, "Date1");
    this.tDate1 = this.getFormattedDateTime(this.toDate1, "Date1");
    this.frmDateResch = this.RoomBookedDetails[index].book_date_from.split("T")[0];
    this.toDateResch = this.RoomBookedDetails[index].book_date_to.split("T")[0];
    console.log("From Date--> ", this.fromDate1);
    console.log("To Date--> ", this.toDate1);
    console.log("From Date Formate--> ", this.fDate1);
    console.log("To Date Formate--> ", this.tDate1);


    this.patientName = this.RoomBookedDetails[index].patientName;
    this.oldBookingId = this.RoomBookedDetails[index].roomBookingId;
    this.patientID = this.RoomBookedDetails[index].patient_id;
    this.reRoomId = this.RoomBookedDetails[index].roomId;
    this.BookedDate = this.RoomBookedDetails[index].booked_date.split("T")[0];

    //------------------------------
    this.presentView = "hospitalDetails";
    this.hospitalDetails = true;
    this.fromBooking = true;
    this.fromBookList = false;

    this.goesToBooking = true;
    this.goesToList = false;
    this.bookingPage = false;
  }


  repeatcheck(index, roomid, details) {
    this.executed1 = true;
    this.bookingpagevalue = true;
    let requestdata = JSON.stringify({
      'roomid': roomid,
    })
    this.checkrepeat = this.services.postRequest("checkrepeatflow", requestdata).subscribe(response => {
      // if( response.data[0].package_status != 0){
        console.log(response.data[0]);
        let repeatres = response.data[0].package_status
        this.repeatressuccess = response.data[0].package_status
        this.repetroomid = roomid
        console.log(repeatres);
        this.repeatIt(index, roomid, details, repeatres)
        this.executed1 = false;
      // }else {
      //   this.Alertpopup(response.data[0].msg,response.data[0].package_status);
      // }
    })
  }

  async repeatIt(index, roomId, roomitem, repeatres) {
    this.Chreselect = true;
    console.log("Room item", roomitem);
    this.datecl = true;
    this.currentMemberId = this.activeRoute.snapshot.paramMap.get('patientId');
    this.isRepeat = true;
    this.RepeatDatas = [];
    this.RepeatDatas.push(this.RoomBookedHistory[index]);
    this.bookingpagevalue = true

    // API DATA'S.............
    this.currentDate = new Date();
    this.fDate1 = this.getFormattedDateTime(new Date(), "Date1");
    let tDate = new Date().setDate(new Date().getDate() + 1);
    this.tDate1 = this.getFormattedDateTime(tDate, "Date1");
    this.fromDate1 = new Date().toISOString().split("T")[0];

    let currentDates = new Date();
    currentDates.setDate(currentDates.getDate() + 1);
    this.toDate1 = currentDates.toISOString().split("T")[0];

    console.log("From Date--> ", this.fromDate1);
    console.log("To Date--> ", this.toDate1);
    console.log("From Date Formate--> ", this.fDate1);
    console.log("To Date Formate--> ", this.tDate1);

    this.patientName = this.RoomBookedHistory[index].patientName;
    this.oldBookingId = this.RoomBookedHistory[index].roomBookingId;
    this.patientID = this.RoomBookedHistory[index].patient_id;
    this.reRoomId = this.RoomBookedHistory[index].roomId;
    await this.openHospitalList(roomitem.Hospitalid, true,0)

    this.fromBooking = false;
    this.goesToBooking = false;
    this.bookingHistory = false;
  }

  async openNdPlay(type: any, path: any, mode: any, thumbnail: any) {
    debugger
    if (this.storedPath === path) {
      this.showPopover1(type, path, thumbnail);
    } else {
      this.storedPath = path;
      this.showPopover1(type, path, thumbnail);
    }
  }

  private async showPopover1(type: any, path: any, thumbnail: any) {
    debugger
    const popover = await this.modalCtrl.create({
      component: MediapopupPage,
      componentProps: {
        Type: type,
        Path: path,
        ThumNail: thumbnail,
      },
      cssClass: 'media-popup',
    });
    await popover.present();
  }
  async openHistory() {
    this.bookingpagevalue = true;
    this.ChangeEvent.emit('isRoomBack');
    this.bookedHistoryList(1);
    this.presentView = "bookingHistory";
    this.bookingHistory = true;
    this.bookingPage = false;
    await this.location()
  }
  backToBookingPage() {
    this.bookedList(3);
    this.presentView = "bookingPage";
    this.bookingPage = true;
    this.isMuteVideo = false;
    this.bookingHistory = false;
    this.bookARoom = false;
    this.isConfirmed = false

  }

  openViewBookingHistoy(index) {
    this.headerValue = this.addCall.title328;
    this.viewBookingHistoryPage = [];
    this.viewBookingHistoryPage.push(this.RoomBookedHistory[index]);
    console.log("My Datas => " + this.viewBookingHistoryPage[0]);
    this.presentView = "viewBookingHistory";
    this.viewBookingHistory = true;
    this.bookingHistory = false;
    this.bookingPage = false;
    this.viewBooking = false;
    this.ChangeEvent.emit('profile');
  }
  backToBookingHistoy() {
    this.presentView = "bookingHistory";
    this.bookingHistory = true;
    this.viewBookingHistory = false;
    this.bookingPage = false;
    this.viewBooking = false;
    this.isMuteVideo = false;
    this.isConfirmed = false

  }

  openViewBooking(index) {
    this.ChangeEvent.emit('profile');
    this.headerValue = this.addCall.title133;
    this.partBookedRoomDetails = [];
    this.partBookedRoomDetails.push(this.RoomBookedDetails[index]);
    console.log("My Datas => " + this.partBookedRoomDetails[0])
    this.presentView = "viewBooking";
    this.viewBooking = true;

    this.viewBookingHistory = false;
    this.bookingHistory = false;
    this.bookingPage = false;
  }
  backToBookingFrmView() {
    this.ChangeEvent.emit('isRoomBack');
    this.presentView = "bookingPage";
    this.bookingPage = true;
    this.isMuteVideo = false;
    this.isConfirmed = false
    this.bookingHistory = false;
    this.viewBooking = false;
  }


  openRefundOption(bkingId, amount, cancelFromDate, patid) {
    console.log("patid", patid);
    this.pat_mem_id = patid;
    let fromDate = cancelFromDate.split("T")[0];
    let newDateNow = new Date(Date.now()).toISOString().split("T")[0];
    console.log("From Date => ", fromDate);
    console.log("Today Date => ", newDateNow);
    console.log("fromDate > todayDate => ", fromDate > newDateNow);
    if (fromDate > newDateNow) {
      this.cancelBkg(bkingId, amount);
      this.totalAmountRefund = amount;
      this.roomBookingId1 = bkingId;
    } else {
      this.BookARoomToast("Your booking already started");
    }
  }

  async cancelBkg(bookingId, bookingAmnt) {
    const modal = await this.modalCtrl.create({
      component: CancelbookingPage,
      cssClass: 'ModelConCSSCancelPopUp',
      componentProps: {
        bookingId: bookingId,
        bookingAmnt: bookingAmnt
      },
    });
    modal.onDidDismiss()
      .then((data) => {
        const res = data;
        console.log(res);
        if (res.data != null) {
          console.log(res.data);
          console.log("booking id=>", res.data.bookingId);
          console.log("booking amnt=>", res.data.bookingAmnt);
          this.patientRoomCancelBooking();
        }
      });
    return await modal.present();
  }

  closeRefundOption() {
    this.showRefundPopUp = false;
  }
  reBackAmount() {
    this.patientRoomCancelBooking();
    this.showRefundPopUp = false;
  }
  proceedToRefund() {
    this.patientRoomCancelBooking();
    this.showRefundPopUp = false;
  }

  RefundOption1() {
    this.showRefundPopUp1 = !this.showRefundPopUp1;
  }
  refundTotalAmount() {
    this.showRefundPopUp1 = false;
    this.currentMemberId = this.activeRoute.snapshot.paramMap.get('patientId');
    this.patientRoomBookingReschedule();
  }
  processRefund() {
    this.showRefundPopUp1 = false;
    this.patientRoomBookingReschedule();
  }







  //API Integration And Events........
  async typeSearchInput() {
    if (this.searchContent != null) {
      this.typeSearch = true;
      this.getRoomList(3);
      await this.patientRoomSearch();
    } else {
      this.typeSearch = false;
    }
  }

  async dynamicFromDate() {
    if (this.executed1 == false) {
      console.log("Executed false");
      this.fromDate1 = new Date(this.fromDate1);
      console.log(this.getFormattedDateTime(this.fromDate1, "Date1"));

      this.fDate1 = this.getFormattedDateTime(this.fromDate1, "Date1");
      let getDate1 = this.fromDate1;
      this.fromDate1 = getDate1.getFullYear() + "-" + ("0" + (getDate1.getMonth() + 1)).slice(-2) + "-" + ("0" + (getDate1.getDate())).slice(-2);
      console.log("From Date API", this.fromDate1);
      let now = new Date().toISOString().split("T")[0];
      if (this.fromDate1 < now) {
        console.log("Now");
        this.fromDate1 = "";
        this.fDate1 = "";
        this.toDate1 = "";
        this.tDate1 = "";
        this.BookARoomToast("From date should be " + this.getFormattedDateTime(now, "Date") + " or above.");
      }
      if (this.fromDate1 >= this.toDate1) {
        console.log("don't know");
        let setToDate = new Date(this.fromDate1).setDate(new Date(this.fromDate1).getDate() + 1);
        this.tDate1 = this.getFormattedDateTime(setToDate, "Date1");
        let getDate = new Date(setToDate);
        this.toDate1 = getDate.getFullYear() + "-" + ("0" + (getDate.getMonth() + 1)).slice(-2) + "-" + ("0" + (getDate.getDate())).slice(-2);;
      }
      // if (this.bookARoom) {
      //   await this.getRoomList(4);
      //   await this.patientRoomSearch();
      // } else if (this.hospitalList) {
      //   this.particularRoomList(2);
      //   await this.particularHospitalRoomList();
      // }
      this.dateFilter = true;
    }
  }

  async dynamicToDate() {
    if (this.executed1 == false) {
      this.toDate1 = new Date(this.toDate1);

      this.tDate1 = this.getFormattedDateTime(this.toDate1, "Date1");
      let getDate1 = this.toDate1;
      this.toDate1 = getDate1.getFullYear() + "-" + ("0" + (getDate1.getMonth() + 1)).slice(-2) + "-" + ("0" + (getDate1.getDate())).slice(-2);
      console.log("To Date API => ", this.toDate1);

      if (this.toDate1 < this.fromDate1) {
        this.toDate1 = "";
        this.tDate1 = "";
        this.BookARoomToast("To data should be " + this.fDate1 + " or above.");
      }

      this.dateFilter = true;
      // if (this.bookARoom) {
      //   await this.getRoomList(5);
      //   await this.patientRoomSearch();
      // } else if (this.hospitalList) {
      //   this.particularRoomList(3);
      //   await this.particularHospitalRoomList();
      // }
    }
  }

  async maxCostRange(event: any) {

    if (this.executed2 == false) {
      this.PatRoomSearch = [];
      this.costStatus = true;
      this.pageno1 = 1
      console.log(this.maxCost, this.minCost, this.mCost);
      await this.patientRoomSearch();
    } else {
      this.executed2 = false;
    }
  }

  async costSort() {
    if (this.executed2 == false) {
      this.costSorting = true;
      if (this.costBasedSortingOrder == "ASC") {
        this.costBasedSortingOrder = "DESC";
      } else if (this.costBasedSortingOrder == "DESC") {
        this.costBasedSortingOrder = "ASC";
      }
      this.particularRoomList(5);
      await this.particularHospitalRoomList();
    } else {
      this.executed2 = false;
    }
  }

  getLenth() {
    document.getElementById("nameInput").style.marginLeft = (this.myNameInput.length + 2) + "px";
  }

  selectMember(name: any, id: any, addr: any) {
    console.log("select member");
    console.log("id", id);
    console.log("name", name);
    console.log("Address", addr);
    this.myNameInput = name;
    this.currentMemberId = id;
    console.log("current member id", this.currentMemberId);

  }

  //API One.........
  async getRoomList(value) {
    // await this.minMaxCostForBookARoom('');
    this.offer_Id = null;
    this.reRoomId = null;
    console.log(value);
    console.log(this.Chreselect);
    this.PatRoomSearch = [];
    this.pageno1 = 1;
    this.limit1 = 10;
    this.skeletonLoad1 = null;
    this.ratingSorting = false;
  }
  async loadDataPage1(event: any) {
    this.scrollEvent = event;
    if (this.nextCountOm == 0) {
      event.target.disabled = true;
    } else {
      this.pageno1 += 1;
      this.limit1 = 10;
      await this.patientRoomSearch();
    }
  }

  async particularRoomList(value) {
    console.log(value);

    this.pageno2 = 1;
    this.partHospRoomList = [];
    this.skeletonLoad2 = null;
    // this.particularHospitalRoomList();
    console.log("check 1");

  }
  nextCount1: any;
  loadDataPage2(event: any) {
    console.log("next count", this.nextCount1);
    this.scrollEvent = event;
    if (this.nextCount1 == 0) {
      event.target.disabled = true;
    } else {
      this.pageno2 += 1;
      this.particularHospitalRoomList();
      console.log("check 1 dateload");
    }
  }

  bookedList(value) {
    console.log("Booked List = ", value);
    this.pageno3 = 1;
    this.RoomBookedDetails = [];
    this.noDataFound = null;
    this.getRoomBookingDetails();
  }

  loadDataPage3(event: any) {
    this.scrollEvent = event;
    console.log(this.nextCount);

    if (this.nextCount == 0) {
      event.target.disabled = true;
    } else {
      this.pageno3 += 1;
      this.getRoomBookingDetails();
    }
  }

  bookedHistoryList(value) {
    console.log("Booked History = ", value);
    this.pageno4 = 1;
    this.RoomBookedHistory = [];
    this.noDataFound = null;
    this.getRoomBookingHistoryDetails();
  }

  loadDataPage4(event: any) {
    this.scrollEvent = event;
    console.log(this.nextCount, "NXT count");

    if (this.nextCount == 0) {
      event.target.disabled = true;
    } else {
      this.pageno4 += 1;
      this.getRoomBookingHistoryDetails();
    }
  }

  onIntersection($event: any, index: any, Sindex: any, details: any) {
    if (index == 0) {
      this.currentVidEvent = $event;
      this.currentVidIndex = index;
      this.currentVidSindex = Sindex;
    }
    const { [InViewportMetadata]: { entry }, target } = $event;
    const ratio = entry.intersectionRatio;
    const vid = target;
    this.currentVideo = target;
    if ($event.visible == false) {
      $event.target.autoplay = false;
    }
    if (this.isMuteVideo) {
      if (ratio >= 0.75 && this.PatRoomSearch) {
        let playPromise = vid.play();

        if (playPromise !== undefined) {
          playPromise.then(_ => {

            if (this.PatRoomSearch?.[index]?.mediaDetails) {
              vid.play();
              this.PatRoomSearch[index].mediaDetails[0].playMode = true;
            }
          })
            .catch((err: any) => {

              console.log(this.PatRoomSearch);
              if (this.PatRoomSearch?.[index]?.mediaDetails) {
                vid.pause();
                this.PatRoomSearch[index].mediaDetails[0].playMode = false;
              }
              console.log(err);
            });
        }
      } else if (this.PatRoomSearch[index].mediaDetails[0].playMode == true) {
        vid.pause();
        this.PatRoomSearch[index].mediaDetails[0].playMode = false;

      }
    }
  }

  playVideo(index: any, Sindex: any, id: any) {
    console.log(id);

    this.playVid = document.getElementById(id);
    if (this.PatRoomSearch[index].mediaDetails[Sindex].playMode == true) {
      this.playVid.pause();
      this.PatRoomSearch[index].mediaDetails[Sindex].playMode = false;
    } else if (this.PatRoomSearch[index].mediaDetails[Sindex].playMode == false) {
      this.playVid.play();
      this.PatRoomSearch[index].mediaDetails[Sindex].playMode = true;
    }
  }

  playProVideo(index, Sindex, mid, value) {
    console.log(Sindex, mid, value);
    this.ProfileVideo = document.getElementById(mid);
    if (this.isPlaying == true) {
      this.ProfileVideo.play();
      this.isPlaying = false;
    }
    else if (this.isPlaying == false) {
      this.ProfileVideo.pause();
      this.ProfileVideo = ""
      this.isPlaying = true;
    }
  }
  //API's.........
 async patientRoomSearch() {
    this.Chreselect = true;
    if (this.roomSearchReq) {
      this.roomSearchReq.unsubscribe();
    }
    this.currentDate = new Date(Date.now()).toISOString().split("T")[0];
    let requestdata = JSON.stringify({
      "pageno": this.pageno1,
      "limit": this.limit1,
      "typesearch": this.typeSearch,
      "searchContent": this.searchContent,
      "dateFilter": this.dateFilter,
      "fromDate": this.fromDate1,
      "toDate": this.toDate1,
      "currentDate": this.currentDate,
      "ratingBasedSorting": this.ratingSorting,
      "ratingBasedSortingOrder": this.ratingBasedSortingOrder,
      "patientId": localStorage.getItem("patient_id"),
      "minCost": this.minCost,
      "maxCost": this.mCost,
      "latitude":this.latitude,
      "longtitude":this.longitude
    });
    this.executed1 = true;
    this.roomSearchReq =  this.services.postRequest("patientRoomSearch", requestdata).subscribe(response => {
      console.log(response);
      if (this.refEvent) {
        this.refEvent.target.complete();
      }
      if (response.data.length > 0) {
        for (let item of response.data[0].details) {
          if (!item.review_comments) {
            item.review_comments = [];
          }
          else {
            item.review_comments = JSON.parse(item.review_comments);;
          }
          if (!item.mediaDetails) {
            item.mediaDetails = [];
          } else {
            item.mediaDetails = JSON.parse(item.mediaDetails);
          }
          this.PatRoomSearch.push(item);
        }
        let convert = JSON.stringify(this.PatRoomSearch);
        this.PatRoomSearch = JSON.parse(convert);
        this.nextCountOm = response.data[0].nextCount;
        this.executed1 = false;
        this.presentView = "bookARoom";
        this.skeletonLoad1 = 1;
        console.log("nextCount => ", this.nextCountOm);
        console.log("show patroom", this.PatRoomSearch);
      }
      else if(this.pageno1 > 1){
        this.PatRoomSearch = this.PatRoomSearch
        this.scrollEvent.target.disabled = true;
        this.skeletonLoad1 = 1;
        this.presentView = "bookARoom";
      }else{
        this.skeletonLoad1 = 0;
      }
    });
  }

  async particularHospitalRoomList() {
    this.executed1 = true;
    // if (this.backhidden == "notshow") {
    //   this.costStatus = false;
    //   this.minCost = "0";
    //   this.mCost = "0";
    // }
    if (this.roomListReq) {
      this.roomListReq.unsubscribe();
    }
    this.currentDate = new Date(Date.now()).toISOString().split("T")[0];

    let requestdata = JSON.stringify({
      "toDate": this.toDate1,
      "fromDate": this.fromDate1,
      "roomVendorId": this.roomVendorId,
      "typesearch": false,
      "searchContent": "",
      "costFilter": this.costStatus,
      "minCost": this.minCost,
      "maxCost": this.mCost,
      "costBasedSorting": this.costSorting,
      "costBasedSortingOrder": this.costBasedSortingOrder,
      "pageno": this.pageno2,
      "limit": 30
    });
    this.roomListReq = this.services.postRequest("particularHospitalRoomList", requestdata).subscribe(response => {
      console.log(response);
      if (this.refEvent) {
        this.refEvent.target.complete();
      }
      this.skeletonLoad2 = response.status;

      if (response.data.length > 0) {
        for (let item of response.data[0].details) {
          this.partHospRoomList.push(item);
        }
        this.nextCount1 = response.data[0].nextCount;
        if (this.offer_Id != null) {
          this.chooseroomdetails(this.offer_Id)
          console.log(this.partHospRoomList);
        }
        this.partHospRoomList.filter(item => {
          if (this.repeatressuccess != 0 && item.roomId == this.repetroomid) {
              this.chooseroomdetails(this.repetroomid);
          }
      });
        console.log("partHospRoomList => ", this.partHospRoomList);
        console.log("nextCount => ", this.nextCount1);
        this.partRoomVendorName = response.data[0].details[0].roomVendorName;
      }
      this.executed1 = false;
    });
  }

  async minMaxCostForBookARoom(val) {
    console.log(val, '====');
    this.checkrepeat = false;

    if (this.costReq) {
      this.costReq.unsubscribe();
    }
    let requestdata = JSON.stringify({
      "roomVendorId": val
    });
    this.costReq = await this.services.postRequest("minMaxCostForBookARoom", requestdata).subscribe(async response => {
      console.log(response);
      if (response.status > 0) {
        this.minCost = response.data[0].minCost;
        this.maxCost = response.data[0].maxCost;
        console.log("cost", this.mCost);
        if (!this.mCost) {
          this.executed2 = true;
          this.mCost = response.data[0].maxCost;
          console.log('check room list API call');
          // this.particularHospitalRoomList();
          // this.particularRoomList(1);
        } else {
          this.executed2 = false;
          this.mCost = response.data[0].maxCost;
        }
        await this.particularHospitalRoomList()
      }
    });
  }

  getParticularRoomDetails(roomId, repeat) {
    if (this.partRoomDetReq) {
      this.partRoomDetReq.unsubscribe();
    }
    this.noDataFound = null;
    this.currentDate = new Date(Date.now()).toISOString().split("T")[0];
    let requestdata = JSON.stringify({
      "currentDate": this.fromDate1,
      "roomId": roomId,
    });
    this.partRoomDetReq = this.services.postRequest("getParticularRoomDetails", requestdata).subscribe(response => {
      console.log(response);
      if (repeat == "repeat") {
        this.dealitem = response.data[0];
      }
      this.noDataFound = response.status;
      if (response.data.length > 0) {
        this.ParticularRoomDetails = [];
        for (let item of response.data) {



          if (!item.facility && !item.mediaDetails) {
            item.facility = [];
            item.mediaDetails = [];
          } else {
            const convert = (arr) => {
              const res = {};
              arr?.forEach((obj) => {
                const key = `${obj.facilityName}`;
                if (!res[key]) {
                  res[key] = { ...obj, count: 0 };
                };
                res[key].count += 1;
              });
              return Object.values(res);
            };
            item.facility = convert(JSON.parse(item.facility))
            item.mediaDetails = JSON.parse(item.mediaDetails);
          }
          this.ParticularRoomDetails.push(item);
          setTimeout(() => {
            if (this.reRoomId == null) {
              this.ionContent.scrollToBottom(500);
            }

          }, 1000);
        }
        let convert = JSON.stringify(this.ParticularRoomDetails);
        this.ParticularRoomDetails = JSON.parse(convert);
        this.roomId = response.data[0].roomId;
        this.roomVendorId = response.data[0].roomVendorId;
        this.roomVendorName = response.data[0].roomVendorName;
        this.cost = response.data[0].cost;
        this.dealopt = response.data[0].dealOption;
        this.delval = response.data[0].dealValue;
      } else {
        this.ParticularRoomDetails = [];
      }
    });
  }

  Email: any;
  Phoneno: any;
  getPatientProfile() {
    if (this.patProReq) {
      this.patProReq.unsubscribe();
    }
    this.currentDate = new Date(Date.now()).toISOString().split("T")[0];
    let time1 = new Date().toTimeString().split("T")[0].split(" ")[0].split(":")[0];
    let time2 = new Date().toTimeString().split("T")[0].split(" ")[0].split(":")[1];
    let currentTime = time1 + ":" + time2;

    let requestdata = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "currentDate": this.currentDate,
      "currentTime": currentTime,
    });
    this.patProReq = this.services.postRequest("getPatientProfile", requestdata).subscribe(response => {
      console.log("patient profile", response);
      console.log("patient check profile", response.data[0]);
      if (response.status == 1) {
        // this.myNameInput = response.data[0].name;
        // this.myAddress = response.data[0].address;
        // this.currentMemberId = localStorage.getItem("patient_id");
        // this.tempMemberName = response.data[0].name;
        // this.PatientProfile = response.data[0];
        // this.Email = response.data[0].email;
        // this.Phoneno = response.data[0].phone_no;
        console.log("address check", this.PatientProfile.address);
      } else {
        this.myNameInput = "";
        this.PatientProfile = [];
      }
    });
  }



  getRoomBookingDetails() {
    if (this.roomBookListReq) {
      this.roomBookListReq.unsubscribe();
    }
    let requestdata = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "limit": 10,
      "pageno": this.pageno3
    });
    this.roomBookListReq = this.services.postRequest("getRoomBookingDetails", requestdata).subscribe(response => {
      console.log(response);
      if (this.refEvent) {
        this.refEvent.target.complete();
      }
      if (this.scrollEvent != undefined) {
        this.scrollEvent.target.complete();
      }
      this.noDataFound = response.status;
      if (response.data.length > 0) {
        for (let item of response.data[0].details) {
          if (new Date(item.book_date_from) > new Date()) {
            item["res_can"] = true;
          } else {
            item["res_can"] = false;
          }
          this.RoomBookedDetails.push(item);
        }
        this.nextCount = response.data[0].nextCount;
        console.log("nextCount => ", this.nextCount);
        console.log(this.RoomBookedDetails);
      }
    })
  }

  historyNXTcount: any;

  getRoomBookingHistoryDetails() {
    if (this.bookHisReq) {
      this.bookHisReq.unsubscribe();
    }
    let requestdata = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "limit": 10,
      "pageno": this.pageno4
    });
    this.bookHisReq = this.services.postRequest("getRoomBookingHistoryDetails", requestdata).subscribe(response => {
      console.log(response);
      if (this.refEvent) {
        this.refEvent.target.complete();
      }
      if (this.scrollEvent != undefined) {
        this.scrollEvent.target.complete();
      }
      this.noDataFound = response.status;
      if (response.data.length > 0) {
        for (let item of response.data[0].details) {
          this.RoomBookedHistory.push(item);
        }
        this.nextCount = response.data[0].nextCount;
        this.historyNXTcount = response.data[0].nextCount;
        console.log("nextCount => ", this.nextCount, this.historyNXTcount);
        console.log(this.RoomBookedHistory);
      }
    });
  }

  async patientRoomBookingReschedule() {
    if (this.roomReschReq) {
      this.roomReschReq.unsubscribe();
    }
    const loading = await this.loadingCtrl.create({
      message: 'Please wait...',
    });
    await loading.present();
    let requestdata = JSON.stringify({
      "oldBookingId": this.oldBookingId,
      "patientId": this.patientID,
      "roomId": Number(this.reRoomId),
      "roomVendorId": this.roomVendorId,
      "bookedDate": this.BookedDate,
      "amount": this.totalCost1,
      "paymentStatus": "1",
      "fromDate": this.fromDate1,
      "toDate": this.toDate1,
      "isMember": 2,
      "tempMemberName": this.myNameInput1,
      "refundStatus": this.refundStatus,
      "refundAmount": this.refundAmount
    });
    this.roomReschReq = this.services.postRequest("patientRoomBookingReschedule", requestdata).subscribe(async response => {
      console.log(response);
      await loading.dismiss();
      if (response.status == 1) {

        this.bookedList(1);
        this.fromPage1 = "page1";
        this.presentView = "bookingPage";
        this.bookingPage = true;

        this.goesToBooking = true;
        this.goesToList = false;
        this.bookingConf2 = false;
        this.Alertpopup(response.msg, response.status);
      } else {
        this.Alertpopup(response.msg, response.status);
      }
    });
  }

  async patientRoomCancelBooking() {
    if (this.roomCancelReq) {
      this.roomCancelReq.unsubscribe();
    }
    const loading = await this.loadingCtrl.create({
      message: 'Please wait...',
    });
    await loading.present();
    let requestdata = JSON.stringify({
      "roomBookingId": this.roomBookingId1,
      "patientId": this.pat_mem_id
    });
    this.roomCancelReq = this.services.postRequest("patientRoomCancelBooking", requestdata).subscribe(async response => {
      console.log(response);
      await loading.dismiss();
      if (response.status == 1) {
        console.log(response.data[0].msgcode, '======================');

        if (response.data[0].msgcode == 2) {
          this.Alertpopup(this.addCall.title449, response.status);
        } else if (response.data[0].msgcode == 1) {
          this.Alertpopup(this.addCall.title450, response.status);
        } else if (response.data[0].msgcode == 3) {
          this.Alertpopup(this.addCall.title451, 0);
        }
        this.bookedList(4);
      } else {
        this.Alertpopup(response.msg, response.status);
        this.BookARoomToast(response.msg);
      }
    });
  }

  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return "";
    }
    let Value;
    switch (callFor) {
      case "Time": {
        if (dateTime.indexOf("T") > -1) {
          Value = dateTime.split("T")[1];
        } else if (dateTime.indexOf(" ") > -1) {
          Value = dateTime.split(" ")[1];
        } else {
          Value = dateTime;
        }
        let hourEnd = Value.indexOf(":");
        let H = +String(Value).substring(0, hourEnd);
        let h = H % 12 || 12;
        let ampm = (H < 12 || H === 24) ? "am" : "pm";
        let timeString = h + String(Value).substring(hourEnd, 3) + " " + ampm;
        if (h < 10) {
          timeString = '0' + timeString;
        }
        return timeString;
      }
      case "Date": {
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy");
      }
      case "DateTime": {
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy h:mm a");
      }
      case "Date1": {
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), "dd-MMM-yy");
        } else {
          let dateCall = new Date(dateTime);
          let months = ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
            "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
          ];
          let day = String(dateCall.getDate()).padStart(2, '0');
          let arDate = day + '-' + months[dateCall.getMonth()] + '-' + dateCall.getFullYear().toString().substring(-2);
          return arDate;
        }
      }
      case "Date2": {
        const formattedDate = formatDate(new Date(dateTime), "dd-MMM-yy, h:mm a", 'en-us');
        const lowercase = formattedDate.replace(/\b[AP]M\b/g, function (match) {
          return match.toLowerCase();
        });
        return lowercase;
      }
      default: {
        return "";
      }
    }
  }


  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }

  //_____________Profile Picture Upload_______________

  async Alertpopup(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      backdropDismiss: false,
      componentProps: {
        'msg': msg,
        'sts': status,
      }
    });
    await alert.present();
    alert.onDidDismiss().then((data) => {
      console.log(data.data);
      if (data.data == 'yes') {
        this.pageno2 = 1;
        this.bookingHistory = false;
        this.Chreselect = true
        this.openHospitalList(this.particularHospitalid, true,0)
      }
    })
  }

  async reviewPopup(Id, proImg, Name, reviewcount, roombooking_id) {

    console.log(reviewcount);
    console.log("Id, proImg, Name, reviewcount, roombooking_id", Id, proImg, Name, reviewcount, roombooking_id);

    if (reviewcount == 0) {
      const alert = await this.modalCtrl.create({
        component: ReviewPage,
        cssClass: 'review-class',
        componentProps: {
          Id: Id,
          Img: proImg,
          Name: Name,
          From: "Room",
          bookingId: roombooking_id,
        }
      });
      alert.onDidDismiss().then((data) => {
        console.log(data);
        if (data.data == 'dismiss') {
          this.openHistory();
        }

      })
      await alert.present();
    }
  }

  async addMember() {
    const modal = await this.modalCtrl.create({
      component: AddmemPage,
      cssClass: 'Add-Member-Page',
      componentProps: {
        getMemName: "",
        getMemGender: "",
        getMemReletion: "",
        getMemHeight: "",
        getMemWeight: "",
        getMemMobileNo: "",
        membDOB: "",
        getMemDob: "",
        memProImg: ""
      },
    });
    modal.onDidDismiss()
      .then((data) => {
        const res = data;
        console.log(res);
        if (res.data.from == 2) {
          this.getPatientProfile();
        }
      });
    return await modal.present();
  }


  particularHospitalid: any;
  reselect(hospitalid) {
    console.log(hospitalid);
    this.particularHospitalid = hospitalid;
    this.Alertpopup(this.addCall.title504, 5);
  }



  particular_hospital: any = [];
  revArr1: any = [];

  async Show_ParticularRoom(roomid) {
    this.executed1 == true;
    this.particular_roomdetails = false;
    this.revArr1 = [];
    this.particular_hospital = [];
    let reqDate = JSON.stringify({
      'vendorId': this.roomVendorId , //18,
      'CurrentDate': new Date().toISOString().split("T")[0],
      'patientid': localStorage.getItem("patient_id"),
    })

    this.services.postRequest('getparticularHospital', reqDate).subscribe(response => {
      this.particular_hospital = response.data[0]
      // }
      this.getMedia(roomid);
      this.revArr1 = JSON.parse(this.particular_hospital.review_comment);

      console.log(this.revArr1, "review");
      let venorlatlong = this.particular_hospital.vendor_latlong
      let lat = venorlatlong.split(',')[0];
      let long = venorlatlong.split(',')[1];
      // this.distanceInKilometers = this.particular_hospital.Distance
      // if (venorlatlong != "" || venorlatlong != undefined || venorlatlong != null) {
      //   this.calculateDistances(lat, long);
      // } else {
      //   this.distanceInKilometers = "0"
      // }
      this.executed1 == false;
    })
  }

  showcoment: boolean = false;
  pagenorev: any;
  revArr: any = [];

  showHide() {
    if (this.showcoment == false) {
      this.revArr = [];
      this.showcoment = true;
      this.pagenorev = 1;
      console.log('open');
    }
    else if (this.showcoment == true) {

      this.revArr.slice(-1)
      this.revArr = [];
      this.showcoment = false;
      this.pagenorev = 1;
      console.log("close");
    }
  }


  profileMediaDetails: any;
  mediaReq: any;
  getMedia(tr_id) {
    this.executed1 == true;
    let tempArr = [];
    if (this.mediaReq) {
      this.mediaReq.unsubscribe();
    }
    this.profileMediaDetails = [];
    let apiData2 = JSON.stringify({
      "doctorId": tr_id,
      "limit": 1000,
      "pageno": 1
    });
    this.mediaReq = this.services.postRequest("getMediaDetailsByDoctor", apiData2).subscribe(res => {
      console.log("mediaDetails=>", res);
      for (let item of res.data[0].details) {
        tempArr.push(item);
        if (tempArr.length == 3) {
          this.profileMediaDetails.push(JSON.parse(JSON.stringify(tempArr)));
          tempArr = [];
        }
      }
      if (tempArr.length > 0) {
        this.profileMediaDetails.push(JSON.parse(JSON.stringify(tempArr)));
      }
      this.executed1 == false;
    });
  }

  selectedroomdetails: any = [];
  roomname: any;


  async select_program() {

    let control = await this.modalCtrl.create({
      component: RoomDetailsPage,
      componentProps: {
        roomdetails: this.partHospRoomList,
      },
      cssClass: 'service-model1'
    })
    control.onDidDismiss().then((data) => {
      console.log(data);
      if (data.data.selected_roomid != null) {
        this.selectedroomdetails = [];
        this.chooseroomdetails(data.data.selected_roomid);

      }
    })
    await control.present();
  }

  offer_Id: any = null;
  chooseroomdetails(data) {
    console.log(data);

    this.roomname = null;
    this.selectedroomdetails = [];
    console.log('selected rom index', this.partHospRoomList);
    if (this.partHospRoomList) {
      for (let i = 0; i < this.partHospRoomList.length; i++) {
        let item = this.partHospRoomList[i];
        if (item.roomId == data) {
          console.log('push data');
          this.selectedroomdetails.push(item);
        }
        if (item.roomId == data) {
          console.log('push data', item.roomModelName);
          this.roomname = item.roomModelName;
        }
      }

    }
    this.fromBookList = true;
    console.log(this.selectedroomdetails);
    this.openHosDetails(data, "")
    if (this.selectedroomdetails[0]?.dealId != null) {
      this.priceTitleShow = true;
    } else {
      this.priceTitleShow = false;
    }
    console.log(this.selectedroomdetails);
    this.repeatressuccess = 0
  }

  likedPopUpStatus: any; dblClikedIndex: any; count: number = 0;

  lastTapTime: number = 0;
  delay: number = 300;
  doubleClick(count, index, hosId, isLiked) {
    const currentTime = new Date().getTime();
    const elapsedTime = currentTime - this.lastTapTime;
    if (elapsedTime < this.delay) {
      let _obj = this;
      this.makeLikes(index, hosId, 1, 2, isLiked == 1 ? "true" : "false");
      this.count += Number(count);
      this.dblClikedIndex = index;
      this.likedPopUpStatus = true;
      setTimeout(() => {
        _obj.likedPopUpStatus = false;
      }, 1000);
    }
    this.lastTapTime = currentTime;
  }

  makeLikes(i, docId, isLyk, from, isLiked) {
    try {
      let data = JSON.stringify({
        vendor_id: docId,
        like: isLyk,
        user_id: localStorage.getItem('patient_id'),
        module_name: 'Room',
        isLiked: isLiked
      });
      this.services.postRequestDoc('UpdateVendorLikes', data)
        .subscribe(
          (res) => {
            console.log(res);
            if (this.PatRoomSearch[i].isLiked != 1) {
              this.PatRoomSearch[i].likes_count =
                Number(this.PatRoomSearch[i].likes_count) + 1;
            }
            this.PatRoomSearch[i].isLiked = 1;
          },
          (err) => {
            console.log(err);
          }
        );
    } catch (err) {
      console.log(err);
    }
  }

  makeLike(index, Hos_id, like, frm, isLiked) {
    console.log('makelike', index, Hos_id, like, frm);
    try {
      if (frm == 1) {
        console.log(frm);

        if (this.PatRoomSearch[index].isLiked == 0) {
          this.PatRoomSearch[index].isLiked = 1;
          this.PatRoomSearch[index].likes_count = Number(this.PatRoomSearch[index].likes_count) + 1;
        }
        else if (this.PatRoomSearch[index].isLiked == 1) {
          this.PatRoomSearch[index].isLiked = 0;
          this.PatRoomSearch[index].likes_count = Number(this.PatRoomSearch[index].likes_count) - 1;
        }
        if (this.PatRoomSearch[index].isLiked == null) {
          this.PatRoomSearch[index].isLiked = 1;
          this.PatRoomSearch[index].likes_count = Number(this.PatRoomSearch[index].likes_count) + 1;
        }

      }
      else if (frm == 2) {
        console.log(frm);
        if (this.particular_hospital.isLiked == 0) {
          this.particular_hospital.isLiked = 1;
          this.particular_hospital.likes_count = Number(this.particular_hospital.likes_count) + 1;
        }
        else if (this.particular_hospital.isLiked == 1) {
          this.particular_hospital.isLiked = 0;
          this.particular_hospital.likes_count = Number(this.particular_hospital.likes_count) - 1;
        }
        if (this.particular_hospital.isLiked == null) {
          this.particular_hospital.isLiked = 1;
          this.particular_hospital.likes_count = Number(this.particular_hospital.likes_count) + 1;
        }

      }
      let data = JSON.stringify({
        "vendor_id": Hos_id,
        "like": like,
        "user_id": localStorage.getItem("patient_id"),
        "module_name": "Room",
        "isLiked": (isLiked == 1) ? "true" : "false"
      });
      this.services.postRequestDoc("UpdateVendorLikes", data).subscribe(res => {
        console.log(res);
      }, (err) => {
        console.log(err);
      });
    }
    catch (err) {
      console.log(err);
    }

  }
  nextcountrev: any;

  loadrevcomments() {

    let requestdata = JSON.stringify({
      'limit': 10,
      'pageno': this.pagenorev,
      'vendorid': this.particular_hospital.vendorid,
      'patientid': localStorage.getItem("patient_id"),
      'vendortypeid': 10
    })

    this.services.postRequest("getVendor_review", requestdata).subscribe(async res => {
      console.log(res.data);
      if (res.data != null) {
        this.nextcountrev = res.data[res.data.length - 1].NextCount;
        for (let item of res.data) {
          this.revArr.push(item)
        }
        if (this.scrollEvent) {
          this.scrollEvent.target.complete()
        }
      }
    });
  }

  onIonInfinite(ev) {
    this.scrollEvent = ev
    if (this.nextcountrev == 0) {
      ev.target.disabled = true
    } else {
      this.pagenorev += 1;
      this.loadrevcomments();
    }
  }

  async offrDtils(myEvent, dealDet, details, i) {
    console.log(details);
    let popover = await this.popoverCtrl.create({
      component: ModpricetagPage,
      event: myEvent,
      componentProps: {
        from: "room",
        dealdetails: dealDet,
      },
      translucent: true,
      cssClass: 'offrMod',
    });
    popover.onDidDismiss().then((data) => {

      if (data.data) {
        this.offer_Id = data.data.datafortrainer.testid;
        console.log(this.offer_Id);
        this.openHospitalList(details.roomVendorId, false,0);
      }

    });
    return await popover.present();
  }

  commonheadervalue: string = "bookroom";
  ngOnChanges() {
    this.commonheadervalue = "bookroom";
    console.log(this.typeid, "=====", this.showTypeofBooking);
    if (this.showTypeofBooking == "booking" || this.showTypeofBooking == "") {
      this.backhidden = "notshow";
      this.openBooking1();
    }
    else if (this.showTypeofBooking == "booking hitory") {
      this.backhidden = "notshow"

      this.openHistory();
    }

  }
  handleImageError(event: any) {
    event.target.src = 'assets/img/Vector.png';
  }
  async opensortpage() {
    const alert = await this.modalCtrl.create({

      component: RatingSortpagePage,
      showBackdrop: true,
      cssClass: 'rating_sort_page',
      backdropDismiss: false,
      componentProps: {
        frm: 'bookroom'
      }
    });
    alert.onDidDismiss().then(async (data) => {
      console.log(data);
      console.log(data.data.orderWise, 'and', data.data.orderby);
      if (data.data.orderWise != null) {

        console.log('data.data.orderWise', data.data.orderWise);
        this.PatRoomSearch = []
        this.ratingSorting = true
        if (data.data.orderWise == "ASC") {
          this.ratingBasedSortingOrder = "ASC"
          console.log(this.ratingBasedSortingOrder);

        }
        else if (data.data.orderWise == "DESC") {
          this.ratingBasedSortingOrder = "DESC"
          console.log(this.ratingBasedSortingOrder);
        }
       await this.patientRoomSearch();
      }
    })


    await alert.present();
  }

  // ====================================Advertisement =============================
  async openAdvr() {
    window.localStorage['addType'] = 2;
    let popover = await this.modalCtrl.create({
      component: AdvertisementPage,
      componentProps: {
        addImg: this.addImg,
        addtype: this.addtype
      },
      cssClass: this.dynClass,
    });
    popover.onDidDismiss()
      .then((data) => {
        const res = data;
        if(window.location.href.includes('/tabs/booking-room')){
          // this.openAdvr();
          if (res.data.isClosedPopUp) {
            this.isMuteVideo = true;
            this.onIntersection(this.currentVidEvent, 0, this.currentVidIndex, this.currentVidSindex);
          }
        }
      });
    return await popover.present();
  }

  async getAdd() {
    try {
      let min = new Date(new Date().setTime(new Date().getTime() + 3600000));
      let CT = min.toISOString().split("T")[0] + "T" + min.toTimeString().split(" ")[0];
      this.tymVal = CT;
      window.localStorage['DocADD'] = CT;

      let today = new Date().toISOString().split("T")[0];
      let data = JSON.stringify({
        "vendor_type_id": 10,
        "current_date": today
      });
      this.services.postRequestGndrl("admin/get_current_advertisement", data).subscribe(res => {
        if (res.data.length > 0) {
          this.addImg = res.data[0].ad_path_name;
          this.addtype = res.data[0].ad_type;
          if (res.data[0].ad_size == "2") {
            this.dynClass = "advertisement1";
          } else if (res.data[0].ad_size == "1") {
            this.dynClass = "advertisement2";
          }
          if(window.location.href.includes('/tabs/booking-room')){
            this.openAdvr();
          }
        }
        else {
          this.isMuteVideo = true;
        }
      }, (err) => {
        console.log(err);
      });
    } catch (err) {
      console.log(err);
    }
  }

  async presentModal1() {

    const modal = await this.modalCtrl.create({
      component: SuccessPage,
      backdropDismiss: false,
      cssClass: 'custom-popupfordeals',
      componentProps: {
        titleContent: 'SUCCESS!',
        messageContent: "pay",

      }
    });
    modal.onDidDismiss().then(async (data) => {

      console.log("data", data);
      this.gopayment = true;
      this.payType = data.data;
      const loading = await this.loadingCtrl.create({
        message: 'Please wait we are redirecting you to the payment gateway',
      });


      const billamountmastercard = this.formatMoney(this.totalCost)
      let number = this.formatMoney(billamountmastercard);
      let billamountknet = number.replace(/,/g, "");
      localStorage.setItem("paymentAmt", billamountknet)
      await this.storepayload();
      if (data.data == "1") {
        await loading.present();
        this.payment.getInitiatePayment(this.tempMemberName, this.Email, this.Phoneno, billamountmastercard)
          await loading.dismiss();
      } else if (data.data == "2") {
        await loading.present();
        // this.payment.getKnetsessionid("", this.Email, this.Phoneno, billamount).then(async (res: any) => {
        this.payment.getKnetPayment(this.tempMemberName, this.Email, this.Phoneno, billamountknet)
          await loading.dismiss();
      }
      // else if (data.data == "3") {
      //   await loading.present();
      //   this.payment.getApplesessionid(this.tempMemberName, this.Email, this.Phoneno, this.totalCost).then(async (res: any) => {
      //     await loading.dismiss();
      //     this.gatewayFunction(res, "APPLE PAY");
      //   })
      // }



      this.payType = "";
      this.gopayment = false
    })
    return await modal.present();

  }

  async showKnetPaymentDetals(data: any, msg: string) {
    const modal = await this.modalCtrl.create({
      component: knetPaymentDetailsPage,
      backdropDismiss: false,
      cssClass: 'custom-popupfordeals',
      componentProps: {
        titleContent: msg,
        messageContent: data,
      }
    });

    modal.onDidDismiss().then(async (data) => {
      if (msg == "Payment Success Details" || msg == "تفاصيل عملية الدفع") {
        // this.router.navigate(['payment', { paymentstatus: 1 }]);
        this.presentView = "paid";
      }
    });
    return await modal.present();
  }
  defaultImage = 'assets/img/Vector.png';
  defaultImages = 'assets/img/fc61f14eeb1769c8fbc5d4902bfc958e.svg';

  onImageError(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = this.defaultImage;
  }
  onImageErrors(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = this.defaultImages;
  }
  isImage(mediaType: string): boolean {
    return mediaType === 'Image' || mediaType === 'image';
  }
  isImageFile(fileType: string): boolean {
    const imageTypes = ['jpg', 'jpeg', 'png', 'svg', 'Jpg', 'Jpeg', 'PNG'];
    return imageTypes.includes(fileType);
  }

  async location() {
    try {
      let options = {
        enableHighAccuracy: true,
        timeout:5000
      };
      await this.geolocation.getCurrentPosition(options).then((resp) => {
        this.LocationIcon = true;
        this.latitude = resp.coords.latitude;
        this.longitude = resp.coords.longitude;
      }, err => {
        this.LocationIcon = false;
        this.latitude = 29.62107798734671;
        this.longitude = 47.587719496877924;
        console.log('Error getting location', err);
      });
    } catch (error) {
      this.lattitude = 29.62107798734671;
      this.longititude = 47.587719496877924;
    }
  }

  getDiscountedtype(type) {
    if (type.toLowerCase() == "percentage") {
      return "%"
    } else {
      return this.addCall.title92
    }
  }
  getDiscountedPrice(item) {
    let discountedPrice = item.dealValue;
    if (item.dealOption === 'Percentage') {
      discountedPrice = item.cost * (1 - item.dealValue / 100);
    } else if (item.dealOption === 'Amount') {
      discountedPrice = item.cost - item.dealValue;
    }
    return discountedPrice.toFixed(3); // Format to 2 decimal places
  }
  async OpenMapMethod(vendor_name: any, vendor_address: any, vendor_latlong: any) {
    const modal = await this.modalCtrl.create({
      component: SuccessPage,
      cssClass: 'mapmodel',
      componentProps: {
        typeValue: 33,
        clinicname: vendor_name,
        clinic_address: vendor_address,
        clinic_lat_long: vendor_latlong,
      }
    });
    modal.onDidDismiss()
    .then((data) => {
      if (data.data == "Map_Not_Show") {
        //  this.ionViewWillEnter();
      }
    });
    return await modal.present();
  }
  formatMoney (number: any) {
    const num = Number(number)
    const options = {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    };

    const formattedNumber = num.toLocaleString('en-US', options);
    const parts = formattedNumber.split('.');
    if (parts.length === 1) {
        return `${formattedNumber}.000`;
      } else {
        const decimalPart = parts[1].padEnd(3, '0');
        return `${parts[0]}.${decimalPart}`;
      }
  }



  decryptContent(encryptedContent: string): string {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedContent, this.fkey, {
        iv: this.fiv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      return error.message;
    }
  }
  formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear().toString().slice(-2);
    return `${day}-${month}-${year}`;
  }

  // openTerms() {
  //   const url = this.services.apiURL() + 'admin/decryptedMemberContent_data';
  //   const params = new HttpParams().set('vendorcategory', 'Room');

  //   this.httpClient.get<DecryptedMemberContentResponse>(url, { params })
  //     .subscribe(
  //       response => {
  //         if (response && response.data && response.data.length > 0) {
  //           const lastIndex = response.data.length - 1;
  //           this.terms_and_condition_file = response.data[lastIndex].Terms_and_conditions;
  //           const decryptedData = this.decryptContent(this.terms_and_condition_file);
  //           console.log("Decrypted data:", decryptedData);

  //           if (!decryptedData) {
  //             throw new Error('Decryption failed');
  //           }

  //           const content = htmlToPdfmake(decryptedData);
  //           console.log("PDF content:", content);

  //           if (!content || !Array.isArray(content)) {
  //             throw new Error('Invalid content structure');
  //           }

  //           const documentDefinition = {
  //             content: content,
  //             styles: {
  //               header: {
  //                 fontSize: 12,
  //                 bold: true,
  //                 margin: [40, 10, 40, 10],
  //               },
  //               footer: {
  //                 fontSize: 10,
  //                 margin: [40, 0, 40, 0],
  //               },
  //               footerText: {
  //                 fontSize: 10,
  //               },
  //             },
  //             header: (currentPage, pageCount, pageSize) => {
  //               const modified_on =  new Date();
  //               return {
  //                 text: ``,
  //                 alignment: 'left',
  //                 style: 'header',
  //                 color: '#510F30',
  //                 margin: [30, 40, 0, 0],
  //               };
  //             },
  //             footer: (currentPage, pageCount, pageSize) => {

  //               const modified_on =  new Date();

  //               return {
  //                 margin: [40, 40, 40, 40],
  //                 columns: [
  //                   {
  //                     stack: [
  //                       {
  //                         text: `Page ${currentPage}/${pageCount}`,
  //                         alignment: "right",
  //                         color: "#510F30",
  //                         style: "footerText",
  //                       },
  //                     ],
  //                   },
  //                 ],
  //               };
  //             },
  //             pageMargins: [40, 70, 40, 180],
  //           };
  //           pdfMake.createPdf(documentDefinition).getBlob(async (blob: Blob) => {
  //             console.log("PDF Blob:", blob);
  //             try {
  //               const localBlob = new Blob([blob], { type: 'application/pdf' });
  //               const fileName = `report_${new Date().getTime()}.pdf`;
  //               await this.file.writeFile(this.file.dataDirectory, fileName, localBlob, { replace: true })
  //                 .then((fileEntry) => {
  //                   console.log("File entry:", fileEntry);
  //                   this.fileOpener.open(fileEntry.nativeURL, 'application/pdf')
  //                     .then(() => console.log('File is opened'))
  //                     .catch(e => console.log('Error opening file', e));
  //                 })
  //                 .catch(e => console.log('Error writing file', e));
  //             } catch (error) {
  //               console.error('Error uploading file', error);
  //             }
  //           });

  //         } else {
  //           console.error('Unexpected response format:', response);
  //         }
  //       },
  //       error => {
  //         console.error('Error:', error);
  //       }
  //     );
  // }

  openTerms () {
    const url = this.services.apiURL() + 'admin/decryptedMemberContent_data';
    const params = new HttpParams().set('vendorcategory', 'Room');

    this.httpClient.get<DecryptedMemberContentResponse>(url, { params })
      .subscribe(
        response => {
        if (response.data && response.data && response.data.length > 0) {
          const lastIndex = response.data.length - 1;
          // setMemberTermsFileName(response.data.data[lastIndex].Terms_and_conditions);

          const content = htmlToPdfmake(this.Decrypted_Editor_content(response.data[lastIndex].Terms_and_conditions));
          const documentDefinition = {
            content: [...content],
            styles: {
              header: {
                fontSize: 12,
                bold: true,
                margin: [40, 10, 40, 10],
              },
              footer: {
                fontSize: 10,

                margin: [40, 0, 40, 0],
              },
              main: {
                margin: [40, 20, 40, 20],
              },
            },
            header: function (currentPage, pageCount, pageSize) {
              if (currentPage != 1) {
              } else {
                return {
                  text: '',
                  margin: [30, 10, 0, 0],
                }
              }
            },
            footer: function (currentPage, pageCount, pageSize) {

              const commonFooter = {
                margin: [40, 0, 40, 40],
                columns: [
                  {
                    stack: [
                      {
                        text: `Page ${currentPage}/${pageCount}`,
                        alignment: "right",
                        color: "#510F30",
                        style: "footerText",
                      },
                    ],
                  },
                ],
              };

              return commonFooter;
            },


            // styles: {
            //   footerText: {
            //     fontSize: 10,
            //   },
            //   footer: {
            //     fontSize: 10,
            //     bold: true,
            //   },
            // },
            pageMargins: [40, 70, 40, 180],
          };


          pdfMake.createPdf(documentDefinition).open();

        }
      },
      error => {
        console.error('Error:', error);
      })
      
      // .catch(function (error) {
      //   console.error('Error in fetching contract list:', error);
      // });
  };

  Decrypted_Editor_content (encryptedContent) {
    const fkey = CryptoJS.enc.Hex.parse(
      "00112233445566778899aabbccddeeff00112233445566778899aabbccddeeff"
    );
    try {
      const fiv = CryptoJS.enc.Hex.parse("00112233445566778899aabbccddeeff");
      // Decrypt content
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedContent, fkey, {
        iv: fiv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      const decryptedContent = decryptedBytes.toString(CryptoJS.enc.Utf8);
      return decryptedContent;
    } catch (error) {
      return error;
    }
  };

  async videoPlayDestroy() {
    console.log("Pausing all videos before navigating away...");

    // Loop through all media and pause videos
    this.PatRoomSearch.forEach((item, index) => {
      item.mediaDetails.forEach((media, mediaIndex) => {
        if (media.playMode === true) {
          const videoElement = document.getElementById(`${index}${media.mediaId}`) as HTMLVideoElement;
          if (videoElement) {
            videoElement.pause(); // Pause the video
          }
        }
      });
    });
    this.isMuteVideo = false;
    this.currentVideo?.pause?.()
    this.currentVidEvent = "";
    this.currentVidIndex = "";
    this.currentVidSindex = "";
    this.partHospRoomList = []; // Clear the room list if needed
  }
  async showaddress(address, myEvent) {
    console.log('checkout address');

    let popover = await this.popoverCtrl.create({
      component: ModpricetagPage,
      event: myEvent,
      componentProps: {
        address: address,
        from: 'roomaddress',
      },
      translucent: true,
      cssClass: 'offrMod',
    });
    popover.onDidDismiss();
    return await popover.present();
  }

  async paymentCheck() {
    debugger;
    if (localStorage.getItem("paymentstatus") == "cancel") {
      this.localClear();
    } else if (localStorage.getItem("paymentstatus") == "completed") {
      let payloaddata = {
        bookId: localStorage.getItem('bookindId'),
        paymentId: localStorage.getItem('resultindicator'),
        sessionid: localStorage.getItem('session'),
        referrence: localStorage.getItem("referenceid"),
        orderId: localStorage.getItem("order_on"),
        paymentGatewayName: localStorage.getItem("paymentGatewayName"),
        paymentStatus: "C",
        status: 1,
        result: "Success",
        amount : localStorage.getItem("paymentAmt")
      }
      if("KNET" == payloaddata.paymentGatewayName){
        await this.gatewayFunction(payloaddata, "KNET");
      }else{
        await this.gatewayFunction(payloaddata, "MASTER");
      }
      console.log(payloaddata);

      let data = JSON.parse(localStorage.getItem("paymentObject"));
    } else if (localStorage.getItem("paymentstatus") == "failed") {
      this.localClear();
    }
  }
  localClear () {
    localStorage.removeItem("paymentstatus")
    localStorage.removeItem("resultindicator")
    localStorage.removeItem("session")
    localStorage.removeItem("order_on")
    localStorage.removeItem("paymentGatewayName")
    localStorage.removeItem("requestdata")
  }

  async storepayload(){
    debugger;
    this.currentDate = new Date().getFullYear() + "-" + (new Date().getUTCMonth() + 1) + "-" + new Date().getDate() + " " + new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds();
    const startDate = new Date(this.fromDate1);
    const endDate = new Date(this.toDate1);
    const timeDifference = endDate.getTime() - startDate.getTime();
    const dayDifference = timeDifference / (1000 * 3600 * 24);
    const totalDays= Math.round(dayDifference);
    let requestdata = JSON.stringify({
      "patientId": this.currentMemberId,
      "roomId": this.roomId,
      "roomVendorId": this.roomVendorId,
      "bookedDate": this.currentDate,
      "amount": this.totalCost,
      "paymentStatus": "1",
      "fromDate": this.fromDate1,
      "toDate": this.toDate1,
      "isMember": this.currentMemberId == 0 ? 0 : 1,
      "tempMemberName": this.tempMemberName,
      "actual_amount": this.deal_check.cost,
      "dealId": this.deal_check.dealId,
      "deal_amount": this.deal_check.dealValue,
      "deal_option": this.deal_check.dealOption,
      "deal_days": this.selectedroomdetails[0].dealsdays,
      "appointmentType": this.currentMemberId != 0 ? 5 : 6,
      "walkinbookingid": this.routeId,
      "totaldays": totalDays,
      // "paymentid": this.paymentid,
      // "referenceid ": this.referenceid,
      // "order_id": this.orderId,
      // "paymentGateway": this.paymentGateway,
    });

    localStorage.setItem("requestdata",requestdata)
  }

}

